import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PrimaryButton from '../../../tailwindUI/PrimaryButton';
import ModalV2 from '../../../tailwindUI/Modal';
import LinkButton from '../../../tailwindUI/LinkButton';
import SecondaryLoader from '../../../hooks/SecondaryLoader';
import Alert from '../../../tailwindUI/Alert';
import Input from '../../../tailwindUI/Input';
import { emailRegex } from '../../../hooks/useRegex';
import { updateOrderAccount } from '../../../apiClient/operations/ordersOperations';

function UpdateOrderAccountModal({ show, setShow, paymentDetails, orderDetails, onSuccess }) {

    const [alert, setAlert] = useState();
    const [showAlert, setShowAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState(null);


    useEffect(() => {
        setShowAlert(alert?.active)
    }, [alert]);

    const updateAccount = async e => {
        try {
            e.preventDefault();
            if (loading) return;

            setLoading(true)
            const email = e.target.elements.email?.value;
            await updateOrderAccount(orderDetails.id, email)
            setLoading(false)
            onSuccess(paymentDetails)
            setShow(false)
        } catch (error) {
            setAlert({ active: true, type: 'Error', message: error.message })
            setLoading(false)
        }

    }

    return (<>

        <ModalV2 show={show} setShow={setShow} className='w-full sm:max-w-[30rem]'>
            <div className='w-full'>
                <div className='pb-3 border-b-2 border-gray-200'>
                    <dl className="grid grid-cols-1 gap-4 sm:grid-cols-1">
                        <div className="flex flex-row items-center">
                            <dd className="mr-2 text-xl font-bold text-gray-900">Cambiar cliente</dd>
                        </div>
                    </dl>
                </div>
                {showAlert && <div className="w-full relative py-3">
                    <Alert show={showAlert} onClose={() => setShowAlert(false)} type={alert.type} title={alert.message} />
                </div>}
                <div className='py-3'>
                    <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                        <div className="sm:col-span-1">
                            <dt className="text-sm font-medium text-gray-500">Fecha de pago</dt>
                            <dd className="mt-1 text-sm text-gray-900">{paymentDetails?.formatted_paid_at}</dd>
                        </div>
                        <div className="sm:col-span-1">
                            <dt className="text-sm font-medium text-gray-500">Total pagado</dt>
                            <dd className="mt-1 text-sm text-gray-900">{paymentDetails?.formatted_amount}</dd>
                        </div>
                    </dl>
                </div>

                <form onSubmit={updateAccount}>
                    <div className='py-3'>
                        <div className="w-full pb-4">
                            <Input
                                label='Correo electrónico del cliente'
                                placeholder='Correo electrónico'
                                type='email'
                                id='email'
                                needed
                                onChange={(e) => (errors?.email !== '' && emailRegex(e.target.value)) && setErrors({ ...errors, email: null })}
                                error={errors?.email} />
                        </div>
                        <div className='w-full flex items-center justify-end'>
                            <div className='w-[7rem]'>
                                <LinkButton type="button" onClick={() => { setShow(false) }}>
                                    Cancelar
                                </LinkButton>
                            </div>
                            <div className='w-[10rem]'>
                                <PrimaryButton type="submit" disabled={errors?.email} isFullWidth>
                                    Cambiar cliente
                                </PrimaryButton>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
        </ModalV2>
        {loading && <SecondaryLoader />}
    </>
    )
}

UpdateOrderAccountModal.propTypes = {
    show: PropTypes.bool,
    setShow: PropTypes.func,
    paymentDetails: PropTypes.object,
    orderDetails: PropTypes.object,
    onSuccess: PropTypes.func
}

export default UpdateOrderAccountModal;